import { Route } from "../Types/Route";

// routes
import Dashboard from "../Views/Dashboard";
import ShootType from "../Views/Booking/ShootType";
import Packages from "../Views/Booking/Packages";
import Date from "../Views/Booking/Date";
import Details from "../Views/Booking/Details";
import Receipt from "../Views/Booking/Receipt";
import Photographers from "../Views/Booking/Photographers";
import Location from "../Views/Booking/Location";
import Page404 from "../Views/Pages/Page404";

const bookingRoutes: Array<Route> = [
  {
    name: "book-type",
    title: "رزور عکاس - نوع رشته",
    icon: "fas fa-plus-circle",
    sidebar: false,
    private: true,
    path: "/book/type",
    component: ShootType,
  },
  {
    name: "book-location",
    title: "رزور عکاس - مکان",
    icon: "fas fa-plus-circle",
    sidebar: false,
    private: true,
    path: "/book/location",
    component: Location,
  },
  {
    name: "book-type",
    title: "رزور عکاس - نوع پکیج",
    icon: "fas fa-plus-circle",
    sidebar: false,
    private: true,
    path: "/book/package",
    component: Packages,
  },
  {
    name: "book-date",
    title: "رزور عکاس - زمان",
    icon: "fas fa-plus-circle",
    sidebar: false,
    private: true,
    path: "/book/date",
    component: Date,
  },
  {
    name: "book-photographers",
    title: "رزور عکاس - انتخاب عکاس",
    icon: "fas fa-plus-circle",
    sidebar: false,
    private: true,
    path: "/book/photographer",
    component: Photographers,
  },
  {
    name: "book-details",
    title: "رزور عکاس - جزيیات",
    icon: "fas fa-plus-circle",
    sidebar: false,
    private: true,
    path: "/book/detail",
    component: Details,
  },
  {
    name: "book-reseipt",
    title: "رزور عکاس - فاکتور",
    icon: "fas fa-plus-circle",
    sidebar: false,
    private: true,
    path: "/book/receipt",
    component: Receipt,
  },
];

export const dashboardRoutes: Array<Route> = [
  ...bookingRoutes,
  {
    name: "dashboard",
    title: "داشبورد",
    path: "/",
    icon: "fas fa-th-large",
    sidebar: false,
    component: Dashboard,
    private: true,
  },
  {
    name: "notFound",
    title: "یافت نشد",
    sidebar: false,
    component: Page404,
    private: false,
  },
];
